import React from "react";
import {PromptDispatchContext} from '../providers';

function useDispatchPrompt() {
    return React.useContext(PromptDispatchContext);
}

export {useDispatchPrompt}
